export const formatAmount = (amount) =>
    new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
}).format(Number(amount) || 0);

export const getFlagUrl = (countryCode) => {
    if (!countryCode) return "";
    return `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;
};

export const getCurrencyInfoByCurrencyCode = (currencyOptions, code) => {
    const normalizedCode = code === 'CHY' ? 'CNY' : code;
    const found = currencyOptions?.find(c => c.currencyCode === normalizedCode || (normalizedCode === 'CNY' && c.currencyCode === 'CHY'));
    if (found) return found;
    if (normalizedCode === 'USD') {
        return {
            id: 'USD',
            currencyName: 'US Dollar',
            currencyCode: 'USD',
            name: 'US Dollar (USD)',
            countryCode: 'US',
            symbol: '$',
            flagUrl: getFlagUrl('US'),
            walletSupported: true,
        };
    }
    if (normalizedCode === 'CNY') {
        return {
            id: 'CNY',
            currencyName: 'Chinese Yuan',
            currencyCode: 'CNY',
            name: 'Chinese Yuan (CNY)',
            countryCode: 'CN',
            symbol: '¥',
            flagUrl: getFlagUrl('CN'),
            walletSupported: false,
        };
    }
    return {};
};

export const getCurrencyInfoByCountryCode = (currencyOptions, code) => {
    const upperCode = code?.toUpperCase();
    const found = currencyOptions?.find(c => c.countryCode?.toUpperCase() === upperCode);
    if (found) return found;
    if (upperCode === 'US') {
        return {
            id: 'USD',
            currencyName: 'US Dollar',
            currencyCode: 'USD',
            name: 'US Dollar (USD)',
            countryCode: 'US',
            symbol: '$',
            flagUrl: getFlagUrl('US'),
            walletSupported: true,
        };
    }
    if (upperCode === 'CN') {
        return {
            id: 'CNY',
            currencyName: 'Chinese Yuan',
            currencyCode: 'CNY',
            name: 'Chinese Yuan (CNY)',
            countryCode: 'CN',
            symbol: '¥',
            flagUrl: getFlagUrl('CN'),
            walletSupported: false,
        };
    }
    return {};
};

export const dataURLtoFile = (dataurl, filename) => {
    if (!dataurl) return null;
    if (dataurl instanceof File || dataurl instanceof Blob) return dataurl;
    if (typeof dataurl !== 'string' || !dataurl.startsWith('data:')) return null;
    try {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)?.[1] || 'application/octet-stream';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename || 'invoice_document.pdf', { type: mime });
    } catch (e) {
        console.error("Error converting dataURL to File", e);
        return null;
    }
};